import React from "react";

interface Props {
  quantity: number;
}

export default ({ quantity }: Props) => (
  <>
    <span className="unit">
      {`${quantity} item${quantity > 1 ? "s" : ""} `}
    </span>
    added to your cart
  </>
);
